export default "__VITE_ASSET__71993523__"